"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUrlResponseWalletToPassOrConnect = exports.createUrlResponseWalletToPass = exports.getRequestPassToWallet = exports.createUrlResponsePassToConnect = exports.cleanResponseWalletToPass = exports.getResponseWalletToPass = exports.createUrlRequestPassToWallet = exports.getRequestConnectToPass = exports.cleanResponsePassToConnect = exports.getResponsePassToConnect = exports.createUrlRequestConnectToPass = void 0;
var query_string_1 = __importDefault(require("query-string"));
function createUrlRequestConnectToPass(url, options) {
    var query = options.action === 'login'
        ? {
            walletType: options.walletType,
            qubicSignInProvider: options === null || options === void 0 ? void 0 : options.qubicSignInProvider,
            redirectUrl: encodeURIComponent(options.redirectUrl),
            apiKey: options.apiKey,
            dataString: encodeURIComponent(options.dataString),
            action: options.action,
        }
        : {
            walletType: options.walletType,
            qubicSignInProvider: options === null || options === void 0 ? void 0 : options.qubicSignInProvider,
            redirectUrl: encodeURIComponent(options.redirectUrl),
            apiKey: options.apiKey,
            dataString: encodeURIComponent(options.dataString),
            clientTicket: options.clientTicket,
            action: 'bind',
        };
    return query_string_1.default.stringifyUrl({
        url: url,
        query: query,
    });
}
exports.createUrlRequestConnectToPass = createUrlRequestConnectToPass;
function getResponsePassToConnect(url) {
    var query = query_string_1.default.parseUrl(url).query;
    if (query.errorMessage) {
        return {
            action: query.action,
            errorMessage: query.errorMessage,
        };
    }
    if (query.action === 'bind') {
        return {
            action: 'bind',
            bindTicket: query.bindTicket,
            expireTime: query.expireTime,
        };
    }
    if (!query.accountAddress || !query.signature || !query.dataString) {
        return null;
    }
    return {
        action: 'login',
        accountAddress: query.accountAddress,
        signature: query.signature,
        dataString: decodeURIComponent(query.dataString),
        isQubicUser: query.isQubicUser === 'true',
    };
}
exports.getResponsePassToConnect = getResponsePassToConnect;
function cleanResponsePassToConnect(currentUrl) {
    var _a = query_string_1.default.parseUrl(currentUrl, { parseFragmentIdentifier: true }), url = _a.url, 
    // remove previous result, key of LoginRequest and errorMessage but keep other query params
    /* eslint-disable @typescript-eslint/no-unused-vars */
    _b = _a.query, accountAddress = _b.accountAddress, signature = _b.signature, dataString = _b.dataString, isQubicUser = _b.isQubicUser, errorMessage = _b.errorMessage, action = _b.action, bindTicket = _b.bindTicket, expireTime = _b.expireTime, restQuery = __rest(_b, ["accountAddress", "signature", "dataString", "isQubicUser", "errorMessage", "action", "bindTicket", "expireTime"]), fragmentIdentifier = _a.fragmentIdentifier;
    /* eslint-enable */
    var removedResultUrl = query_string_1.default.stringifyUrl({
        url: url,
        query: restQuery,
        fragmentIdentifier: fragmentIdentifier,
    });
    return removedResultUrl;
}
exports.cleanResponsePassToConnect = cleanResponsePassToConnect;
// in Pass
function getRequestConnectToPass(url) {
    var query = query_string_1.default.parseUrl(url).query;
    if (!query.redirectUrl) {
        return undefined;
    }
    return query.action === 'login'
        ? {
            walletType: query.walletType,
            qubicSignInProvider: query.qubicSignInProvider,
            redirectUrl: decodeURIComponent(query.redirectUrl),
            apiKey: query.apiKey,
            dataString: decodeURIComponent(query.dataString),
            action: 'login',
        }
        : {
            walletType: query.walletType,
            qubicSignInProvider: query.qubicSignInProvider,
            redirectUrl: decodeURIComponent(query.redirectUrl),
            apiKey: query.apiKey,
            dataString: decodeURIComponent(query.dataString),
            clientTicket: query.clientTicket,
            action: 'bind',
        };
}
exports.getRequestConnectToPass = getRequestConnectToPass;
function createUrlRequestPassToWallet(url, options) {
    var query = {
        ticketRedirectUrl: encodeURIComponent(options.ticketRedirectUrl),
        provider: options.provider,
    };
    return query_string_1.default.stringifyUrl({
        url: url,
        query: query,
    });
}
exports.createUrlRequestPassToWallet = createUrlRequestPassToWallet;
function getResponseWalletToPass(url) {
    var query = query_string_1.default.parseUrl(url).query;
    if (query.errorMessage) {
        return {
            errorMessage: query.errorMessage,
        };
    }
    return {
        ticket: query.ticket,
        expiredAt: Number(query.expiredAt),
        address: query.address,
    };
}
exports.getResponseWalletToPass = getResponseWalletToPass;
function cleanResponseWalletToPass(currentUrl) {
    var _a = query_string_1.default.parseUrl(currentUrl, { parseFragmentIdentifier: true }), url = _a.url, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _b = _a.query, ticket = _b.ticket, expiredAt = _b.expiredAt, address = _b.address, errorMessage = _b.errorMessage, restQuery = __rest(_b, ["ticket", "expiredAt", "address", "errorMessage"]), fragmentIdentifier = _a.fragmentIdentifier;
    var removedResultUrl = query_string_1.default.stringifyUrl({
        url: url,
        query: restQuery,
        fragmentIdentifier: fragmentIdentifier,
    });
    return removedResultUrl;
}
exports.cleanResponseWalletToPass = cleanResponseWalletToPass;
function createUrlResponsePassToConnect(url, options) {
    return query_string_1.default.stringifyUrl({
        url: url,
        query: options,
    });
}
exports.createUrlResponsePassToConnect = createUrlResponsePassToConnect;
// wallet
function getRequestPassToWallet(url) {
    var query = query_string_1.default.parseUrl(url).query;
    if (!query.ticketRedirectUrl) {
        return undefined;
    }
    return {
        ticketRedirectUrl: decodeURIComponent(query.ticketRedirectUrl),
        provider: query.provider,
    };
}
exports.getRequestPassToWallet = getRequestPassToWallet;
function createUrlResponseWalletToPass(url, options) {
    if ('errorMessage' in options) {
        return query_string_1.default.stringifyUrl({
            url: url,
            query: { errorMessage: options.errorMessage },
        });
    }
    var query = {
        ticket: options.ticket,
        expiredAt: options.expiredAt,
        address: options.address,
    };
    return query_string_1.default.stringifyUrl({
        url: url,
        query: query,
    });
}
exports.createUrlResponseWalletToPass = createUrlResponseWalletToPass;
function createUrlResponseWalletToPassOrConnect(url, options) {
    var nextUrl = createUrlResponseWalletToPass(url, options);
    var params = getResponseWalletToPass(nextUrl);
    var requestConnectToPassParams = getRequestConnectToPass(nextUrl);
    if (!requestConnectToPassParams ||
        !requestConnectToPassParams.redirectUrl ||
        requestConnectToPassParams.action === 'bind') {
        // not detecting url just go back to pass
        return nextUrl;
    }
    // if we detect redirectUrl we skip pass web, go to connect sdk directly
    if ('errorMessage' in params) {
        return createUrlResponsePassToConnect(params.redirectUrl, {
            action: requestConnectToPassParams.action,
            errorMessage: params.errorMessage,
        });
    }
    if (!requestConnectToPassParams.dataString) {
        throw Error('params data string Not found');
    }
    return createUrlResponsePassToConnect(requestConnectToPassParams.redirectUrl, {
        accountAddress: params.address,
        signature: params.ticket,
        dataString: requestConnectToPassParams.dataString,
        isQubicUser: true,
        action: 'login',
    });
}
exports.createUrlResponseWalletToPassOrConnect = createUrlResponseWalletToPassOrConnect;
